module.exports = __webpack_public_path__ + "static/media/fp-cl-icon.8f71d0e9.svg";